import { render } from "./newCommentForm.vue?vue&type=template&id=0d8250b3&scoped=true&ts=true"
import script from "./newCommentForm.vue?vue&type=script&lang=ts"
export * from "./newCommentForm.vue?vue&type=script&lang=ts"

import "./newCommentForm.vue?vue&type=style&index=0&id=0d8250b3&scoped=true&lang=css"

import exportComponent from "C:\\projects\\equistasi\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d8250b3"]])

export default __exports__